export default "__VITE_ASSET__CuYf4FHi__"